module.exports = __webpack_public_path__ + "static/media/playground.afbee317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/playground.jpg
// module id = 352
// module chunks = 0